import { render, staticRenderFns } from "./document-training-report.vue?vue&type=template&id=002aac84&"
import script from "./js/document-training-report.js?vue&type=script&lang=js&"
export * from "./js/document-training-report.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports